"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { DataBuilderFormulaType } from '@membranehq/sdk';
import { EditorTagBadge, EditorTagBadgeIcon } from '../../ComboBox/Badges/EditorTagBadge/index.mjs';
import { SvgIconType } from '../../SvgIcon/svg-icon-type.mjs';
import { useIntegrationAppConnection } from '../../../contexts/use-integration-app-connection.mjs';
import { useMembraneClient } from '../../../contexts/use-membrane-client.mjs';
import { forwardRef } from 'react';
import { DataLinkTablesOptionsFactory } from '../../DataLinks/data-link-tables-option-factory.mjs';
import { Truncate } from '../../Truncate/index.mjs';
import { makeSubField } from '../data-field.mjs';
import { DataBuilderFormField } from '../DataBuilderFormField.mjs';
import useDataBuilder from '../use-data-builder.mjs';
import useDataBuilderField from '../use-data-builder-field.mjs';

const FindAppRecordIdFormula = forwardRef(
  (props, ref) => {
    return /* @__PURE__ */ jsxs(EditorTagBadge, { variant: "formula", ref, onDelete: props.onDelete, children: [
      /* @__PURE__ */ jsx(EditorTagBadgeIcon, { type: SvgIconType.Array }),
      " ",
      /* @__PURE__ */ jsx(Truncate, { children: "Find App Record ID" })
    ] });
  }
);
function FindAppRecordIdFormulaDropdown({
  formula,
  onChange
}) {
  const { field } = useDataBuilderField();
  const { client } = useMembraneClient();
  const { connectionId } = useIntegrationAppConnection();
  const { isAdminMode } = useDataBuilder();
  if (formula?.type !== DataBuilderFormulaType.FIND_APP_RECORD_ID) {
    return /* @__PURE__ */ jsx("span", { children: "Unexpected value for drilldown. Something went wrong." });
  }
  const args = formula.args ?? {};
  const { dataLinkTable, recordId } = args;
  function handleChange(value) {
    onChange?.({
      $findAppRecordId: {
        ...args,
        ...value
      }
    });
  }
  function handleDataLinkTableKeyChange(value) {
    handleChange({
      dataLinkTable: {
        key: value
      }
    });
  }
  function handleRecordIdChange(value) {
    handleChange({
      recordId: value
    });
  }
  function makeDataLinkTableField() {
    return makeSubField(field, {
      valueLocator: `${field.valueLocator}.dataLinkTable.key`,
      value: dataLinkTable?.key,
      schema: { type: "string", title: "Data Link Table" },
      optionFactories: [
        new DataLinkTablesOptionsFactory({
          client,
          connectionId,
          /* FIXME: strictNullCheck temporary fix */
          // @ts-expect-error TS(2322): Type 'boolean | undefined' is not assignable to ty... Remove this comment to see the full error message
          isAdminMode
        })
      ],
      exampleVariables: null,
      variablesSchema: null,
      level: 1,
      /* FIXME: strictNullCheck temporary fix */
      // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string | un... Remove this comment to see the full error message
      key: null,
      isInSchema: true
    });
  }
  function makeRecordIdField() {
    return makeSubField(field, {
      valueLocator: `${field.valueLocator}.$findAppRecordId.recordId`,
      schema: { type: "string", title: "External Record Id" },
      optionFactories: field.optionFactories,
      exampleVariables: field.exampleVariables,
      variablesSchema: field.variablesSchema,
      level: 1,
      /* FIXME: strictNullCheck temporary fix */
      // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string | un... Remove this comment to see the full error message
      key: null,
      value: recordId,
      isInSchema: true
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(DataBuilderFormField, { field: makeDataLinkTableField(), onChange: handleDataLinkTableKeyChange }),
    /* @__PURE__ */ jsx(DataBuilderFormField, { field: makeRecordIdField(), onChange: handleRecordIdChange })
  ] });
}

export { FindAppRecordIdFormulaDropdown, FindAppRecordIdFormula as default };
